export const LINKS_RESET_DATA = 'REFERRAL/LINKS_RESET_DATA'
export const LINKS_SET_FILTERS = 'REFERRAL/LINKS_SET_FILTERS'
// export const LINKS_FILTERS_APPLY = 'REFERRAL/LINKS_FILTERS_APPLY'
export const LINKS_SET_DATA = 'REFERRAL/LINKS_SET_DATA'
export const LINKS_FETCH = 'REFERRAL/LINKS_FETCH'
export const LINKS_UPDATE_LINK = 'REFERRAL/LINKS_UPDATE_LINK'
export const FINANCIAL_TERMS_FETCH = 'REFERRAL/FINANCIAL_TERMS_FETCH'
export const LINKS_CREATE_LINK = 'REFERRAL/LINKS_CREATE_LINK'
export const LINKS_FETCH_LINK = 'REFERRAL/LINKS_FETCH_LINK'
